import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslatePipe } from '@ngx-translate/core'

import { EditorThread } from '../editor-thread.types'
import { getFirstComment, toCommentHeaderMeta } from '../editor-thread.selectors'
import { SuggestionMetaComponent } from '../suggestion-meta/suggestion-meta.component'

@Component({
  selector: 'app-comment-popup',
  standalone: true,
  imports: [MatIconModule, TranslatePipe, SuggestionMetaComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './comment-popup.component.html',
  styleUrl: './comment-popup.component.scss',
})
export class CommentPopupComponent implements OnChanges {
  @Input({ required: true })
  anchorId!: string

  @Input()
  thread: EditorThread | null = null

  @Output()
  viewThread = new EventEmitter<string>()

  authorName: string | null = null
  createdAtRelative: string | null = null
  commentBody: string | null = null

  ngOnChanges() {
    const meta = toCommentHeaderMeta(this.thread)
    this.authorName = meta.authorName
    this.createdAtRelative = meta.createdAtRelative
    this.commentBody = getFirstComment(this.thread)?.body ?? null
  }

  onViewThread() {
    this.viewThread.emit(this.anchorId)
  }
}
